import { api } from '../../../services/api/client';
import type { User } from '../../../types';

export interface AdminUserUpdate {
  roles?: string[];
  status?: string;
  is_vip?: boolean;
}

export async function adminListUsers(): Promise<User[]> {
  const { data } = await api.get<User[]>('/admin/users');
  return data;
}
export async function adminUpdateUser(id: string, payload: AdminUserUpdate): Promise<User> {
  const { data } = await api.put<User>(`/admin/users/${id}`, payload);
  return data;
}
export async function adminDeleteUser(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/users/${id}`);
  return data;
}
export async function adminResetUserPassword(id: string, new_password: string): Promise<any> {
  const { data } = await api.post(`/admin/users/${id}/reset-password`, { new_password });
  return data;
}

export interface LocationStatItem {
  name: string;
  count: number;
}
export interface LocationStats {
  total_with_location: number;
  by_region: LocationStatItem[];
  by_country: LocationStatItem[];
}
export async function adminLocationStats(): Promise<LocationStats> {
  const { data } = await api.get<LocationStats>('/admin/users/location-stats');
  return data;
}
